__turbopack_context__.v({
  "pixel": "AnCDGW_pixel",
  "pixel-on": "AnCDGW_pixel-on",
});
